import React from 'react';

import { Permissions } from 'src/app_deprecated/constants/PermissionsConstants';

import { FormSection } from 'src/app/components/lib/form';
import { Radio, RadioGroup } from 'src/app/components/lib/radio';
import { WizardCard } from 'src/app/components/lib/wizard/card';
import { usePermissionCheck } from 'src/app/state/user-permissions';

import { CalculationMethods } from '../../../models';
import { useDiscountWizardStateContext } from '../../state';
import { RewardsStepActions } from '../../state/rewards';

import { TextWrapper } from './styled';

export function AdditionalSettingsCard() {
  const {
    rewardsStepState: { allowStacking, ignoreNetTaxes, discountMethod },
    rewardsStepDispatch,
  } = useDiscountWizardStateContext();

  const canEditTaxes = usePermissionCheck(Permissions.EditTaxRates);
  const isLoyaltyBooster = discountMethod === CalculationMethods.LoyaltyMultiplier;

  return (
    <WizardCard
      description={<AdditionalSettingsDescription canEditTaxes={canEditTaxes} isLoyaltyBooster={isLoyaltyBooster} />}
      title='Additional settings'
    >
      <FormSection>
        <RadioGroup
          label='Allow stacking:'
          labelPlacement='top'
          tooltip='Set whether this discount should be allowed to apply on top of other discounts. If set to yes, this discount will always apply to eligible carts regardless of other discounts.'
          useV2Tooltip
          variant='boolean'
          onChange={({ target }) =>
            rewardsStepDispatch({
              type: RewardsStepActions.SET_ALLOW_STACKING,
              payload: target.value !== 'false',
            })
          }
        >
          <Radio checked={allowStacking} disabled={isLoyaltyBooster} label='Yes' value />
          <Radio checked={!allowStacking} disabled={isLoyaltyBooster} label='No' value={false} />
        </RadioGroup>

        {canEditTaxes && (
          <RadioGroup
            label='Ignore net taxes:'
            labelPlacement='top'
            variant='boolean'
            onChange={({ target }) =>
              rewardsStepDispatch({
                type: RewardsStepActions.SET_IGNORE_NET_TAXES,
                payload: target.value !== 'false',
              })
            }
          >
            <Radio checked={ignoreNetTaxes} label='Yes' value />
            <Radio checked={!ignoreNetTaxes} label='No' value={false} />
          </RadioGroup>
        )}
      </FormSection>
    </WizardCard>
  );
}

function AdditionalSettingsDescription({
  canEditTaxes,
  isLoyaltyBooster,
}: {
  canEditTaxes: boolean;
  isLoyaltyBooster: boolean;
}) {
  return (
    <TextWrapper>
      {!isLoyaltyBooster && <p>Stacking allows you to combine this discount with other active discounts.</p>}
      {isLoyaltyBooster && <p>Stacking is always enabled for loyalty boosters.</p>}
      {canEditTaxes && <p>Ignoring net taxes will tax discounted items as if the discount did not apply.</p>}
    </TextWrapper>
  );
}
